import React from "react";

function MemberCard({ name, designation, image, linkedIn, imageScale, aspectClass }) {
  return (
    <div
      className="flex flex-col items-center justify-start w-full h-full rounded-lg overflow-hidden"
      style={{ boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.12)" }}
    >
      {/* Image — grows to fill available card height or uses fixed aspect ratio */}
      <div className={`w-full bg-[#DAE9FF] ${aspectClass ? aspectClass : "flex-1 min-h-0"} overflow-hidden`}>
        <img
          src={image ? image : "/assets/images/Team/default-user.png"}
          alt={name}
          className="w-full h-full object-cover object-top"
          style={imageScale ? { transform: `scale(${imageScale})` } : undefined}
        />
      </div>

      {/* Info — fixed height so all cards have identical bottom strip */}
      <div className="flex flex-col w-full px-4 py-3 shrink-0 h-[88px] overflow-hidden">
        <div className="flex justify-between items-start w-full gap-2">
          <p className="text-base font-[500] text-left leading-tight">{name}</p>
          {linkedIn && (
            <a
              href={linkedIn}
              target="_blank"
              rel="noopener noreferrer"
              className="shrink-0 mt-0.5 text-[#0077b5] hover:text-[#005885] transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                className="w-5 h-5"
                fill="currentColor"
              >
                <path d="M416 32L31.9 32C14.3 32 0 46.5 0 64.3L0 447.7C0 465.5 14.3 480 31.9 480L416 480c17.6 0 32-14.5 32-32.3l0-383.4C448 46.5 433.6 32 416 32zM135.4 416l-66.4 0 0-213.8 66.5 0 0 213.8-.1 0zM102.2 96a38.5 38.5 0 1 1 0 77 38.5 38.5 0 1 1 0-77zM384.3 416l-66.4 0 0-104c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9l0 105.8-66.4 0 0-213.8 63.7 0 0 29.2 .9 0c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9l0 117.2z" />
              </svg>
            </a>
          )}
        </div>
        <p
          className="text-sm text-gray-600 text-left mt-1 leading-snug"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {designation}
        </p>
      </div>
    </div>
  );
}

export default MemberCard;
